export default {
  setBreadcrumbs(context, payload) {
    context.commit('setBreadcrumbs', payload);
  }
};
